var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"profile",attrs:{"fluid":""}},[_c('h1',[_vm._v("Mi perfil")]),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }